import { connect } from 'react-redux';
import PagesFormView from './index'
import {updatePage, loadPages, savePage} from '../../actions/Pages'


const mapStateToProps = (state, props) => {
    
    return {

    }
}

const mapDispatchToProps = (dispatch, state) => {
  
    return {
	savePage: (data) => {
	    return dispatch(savePage(data)).then(() =>  dispatch(loadPages()))
	},
	updatePage: (data) => {
	    return dispatch(updatePage(data)).then(() =>  dispatch(loadPages()))
	}
    }
}

const PagesFormContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PagesFormView);




export default PagesFormContainer;



// WEBPACK FOOTER //
// ./src/components/PagesForm/Container.js